
export function getOlRotation() {
    return window.map.getView().getRotation()
}
